import React from 'react'
import classes from './Prices.module.css'
import { EmployerLayout } from '../Layout/EmployerLayout'
import { Button } from '../../../components/Button/Button'

interface Props {

}

export const Prices: React.FC<Props> = () => {

    return (
        <EmployerLayout>
            <div className={classes.Container}>
              <div className={classes.current}>
                <div className={classes.currentHead}>
                  <p className={classes.headTitle}> :الباقة الحالية</p>
                  <p className={classes.headValue}>تجريبية</p>
                </div>
                <div className={classes.aboutCurrent}>
                  <div className={classes.aboutTitles}>
                    <p>بدأت في</p>
                    <p>تنتهي في</p>
                    <p>المدة</p>
                    <p>اعلانات الوظائف</p>
                  </div>
                  <div className={classes.aboutValues}>
                    <p>20-10-2012</p>
                    <p>20-11-2012</p>
                    <p>30 يوماً</p>
                    <p>2/0</p>
                  </div>
                </div>
              </div>
              <div className={classes.packages}>
                  <div className={classes.packageContainer}>
                    <div className={classes.package}>
                      <div className={classes.packageName}>
                        <p>سوبر بلس</p>
                      </div>
                      <div className={classes.packagePrice}>
                        <p className={classes.priceNumber}>4000</p>
                        <p className={classes.priceText}>جنيه / شهرياً</p>
                      </div>
                      <div className={classes.features}>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>عدد لانهائي من الوظائف</p>
                        </div>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>عرض اللوجو في الصفحة الرئيسية</p>
                        </div>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>دعم فني 24 ساعة</p>
                        </div>
                      </div>
                    </div>
                    <Button style={{marginTop: 15}} color={'#386A34'}>الإشتراك الآن</Button>
                  </div>
                  <div className={classes.packageContainer}>
                    <div className={classes.package}>
                      <div className={classes.packageName}>
                        <p>سوبر</p>
                      </div>
                      <div className={classes.packagePrice}>
                        <p className={classes.priceNumber}>1850</p>
                        <p className={classes.priceText}>جنيه / شهرياً</p>
                      </div>
                      <div className={classes.features}>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>عدد 7 اعلان وظيفة</p>
                        </div>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>عرض اللوجو في الصفحة الرئيسية</p>
                        </div>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>دعم فني 24 ساعة</p>
                        </div>
                      </div>
                    </div>
                    <Button style={{marginTop: 15}} color={'#386A34'}>الإشتراك الآن</Button>
                  </div>
                  <div className={classes.packageContainer}>
                    <div className={classes.package}>
                      <div className={classes.packageName}>
                        <p>كونكت بلس</p>
                      </div>
                      <div className={classes.packagePrice}>
                        <p className={classes.priceNumber}>950</p>
                        <p className={classes.priceText}>جنيه / شهرياً</p>
                      </div>
                      <div className={classes.features}>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>عدد 5 اعلان وظيفة</p>
                        </div>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>دعم فني 24 ساعة</p>
                        </div>
                      </div>
                    </div>
                    <Button style={{marginTop: 15}} color={'#386A34'}>الإشتراك الآن</Button>
                  </div>
                  <div className={classes.packageContainer}>
                    <div className={classes.package}>
                      <div className={classes.packageName}>
                        <p>كونكت</p>
                      </div>
                      <div className={classes.packagePrice}>
                        <p className={classes.priceNumber}>450</p>
                        <p className={classes.priceText}>جنيه / شهرياً</p>
                      </div>
                      <div className={classes.features}>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>عدد 2 اعلان وظيفة</p>
                        </div>
                        <div className={classes.feature}> 
                          <div className={classes.dot}/>
                          <p className={classes.featureText}>دعم فني 24 ساعة</p>
                        </div>
                      </div>
                    </div>
                    <Button style={{marginTop: 15}} color={'#386A34'}>الإشتراك الآن</Button>
                  </div>
                  
                  
              </div>
            </div>
        </EmployerLayout>
    )
}